import { Routes, Route } from "react-router-dom";
import RootLayout from "./RootLayout";
import HomePage from "./app/page";
import HostingPage from "./app/hosting/page";
import SharedHostingPage from "./app/hosting/shared-hosting/page";
import WordPressHostingPage from "./app/hosting/wordpress-hosting/page";
import VpsHostingPage from "./app/hosting/vps-hosting/page";
import DedicatedServerPage from "./app/hosting/dedicated-server/page";
import ContactPage from "./app/contact/page";
import BlogPage from "./app/blog/page";
import AboutPage from "./app/about/page";
import DomainsPage from "./app/domains/page";
import PrivacyPolicyPage from "./app/privacy-policy/page";
import AcceptableUsePolicyPage from "./app/acceptable-use-policy/page";
import TermsOfServicesPage from "./app/terms-of-services/page";
import RefundPolicyPage from "./app/refund-policy/page";
import NotFoundPage from "./app/not-found";
import BlogCheapestShared from "./app/the-cheapest-shared-hosting-in-the-market-a-comprehensive-comparison/page";
import BlogSpeedPerformance from "./app/how-our-hosting-service-can-improve-your-websites-speed-and-performance/page";
import BlogSharedToDedicated from "./app/from-shared-to-dedicated-hosting-which-service-is-right-for-you-and-why/page";
import BlogCloudVsTraditional from "./app/cloud-hosting-vs-traditional-hosting-making-the-right-choice/page";
import Blog10Questions from "./app/10-questions-to-ask-before-choosing-a-hosting-service-for-your-website/page";
import BlogDomainGuide from "./app/the-ultimate-guide-to-choosing-the-perfect-domain-name/page";
import BlogSecurityPriority from "./app/why-security-should-be-a-top-priority-when-choosing-a-hosting-service/page";
import BlogFreeHosting from "./app/the-pros-and-cons-of-free-hosting-services-why-you-get-what-you-pay-for/page";

export default function App() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/hosting" element={<HostingPage />} />
        <Route path="/hosting/shared-hosting" element={<SharedHostingPage />} />
        <Route path="/hosting/wordpress-hosting" element={<WordPressHostingPage />} />
        <Route path="/hosting/vps-hosting" element={<VpsHostingPage />} />
        <Route path="/hosting/dedicated-server" element={<DedicatedServerPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/domains" element={<DomainsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/acceptable-use-policy" element={<AcceptableUsePolicyPage />} />
        <Route path="/terms-of-services" element={<TermsOfServicesPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route
          path="/the-cheapest-shared-hosting-in-the-market-a-comprehensive-comparison"
          element={<BlogCheapestShared />}
        />
        <Route
          path="/how-our-hosting-service-can-improve-your-websites-speed-and-performance"
          element={<BlogSpeedPerformance />}
        />
        <Route
          path="/from-shared-to-dedicated-hosting-which-service-is-right-for-you-and-why"
          element={<BlogSharedToDedicated />}
        />
        <Route
          path="/cloud-hosting-vs-traditional-hosting-making-the-right-choice"
          element={<BlogCloudVsTraditional />}
        />
        <Route
          path="/10-questions-to-ask-before-choosing-a-hosting-service-for-your-website"
          element={<Blog10Questions />}
        />
        <Route
          path="/the-ultimate-guide-to-choosing-the-perfect-domain-name"
          element={<BlogDomainGuide />}
        />
        <Route
          path="/why-security-should-be-a-top-priority-when-choosing-a-hosting-service"
          element={<BlogSecurityPriority />}
        />
        <Route
          path="/the-pros-and-cons-of-free-hosting-services-why-you-get-what-you-pay-for"
          element={<BlogFreeHosting />}
        />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
